var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaritacaSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "96 106 352 386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #1a3c34;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 216.75,
    y1: 124.97,
    x2: 364.43,
    y2: 461.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a3c34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a3c34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 288.57,
    y1: 617.22,
    x2: 193.84,
    y2: 187.35,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.21,408.77h65.06s-132.4-134.03-172.1-175.85c-6.88-7.25-18.5-6.61-24.76,1.19-12.67,15.78-20.33,35.27-21.56,55.76-1.65,27.52,8.41,54.66,27.6,74.46l115.75,116.86h82.54l-72.52-72.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.21,408.61l-31.02-31.31c-22.87-23.6-34.82-55.84-32.86-88.55,1.96-32.7,17.68-63.29,43.14-83.92,0,0,.04-.01.02-.07,9.24,1.54,18.95-.63,26.8-6.48-1.88-6.41-4.31-14.53-5.92-19.89-.58-1.94,1.58-3.54,3.26-2.41l30.78,20.56c8.1-16.32,5.83-36.44-6.86-50.6,2.66-4.87,1.72-11.62-4.1-15.06-13.06-7.72-31.79-14.71-57.13-14.71-43.86,0-117.34,39.81-117.34,137.59,0,56.28,36.16,121.59,102.71,145.55l-38.09,81.87h27.81l35-75.23c7.61,1.4,15.51,2.33,23.75,2.67l-33.76,72.57h27.81l24.89-53.5-18.89-19.07h0ZM234.61,134.08c6.1,0,11.04,4.94,11.04,11.04s-4.94,11.04-11.04,11.04-11.04-4.94-11.04-11.04,4.94-11.04,11.04-11.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaritacaSymbol);
export default __webpack_public_path__ + "static/media/maritaca-symbol.896cf99c197aea228b9459adf6bdea1d.svg";
export { ForwardRef as ReactComponent };